import { createContext } from "react";

type SectorContextType = {
    sector: number;
    setSector: React.Dispatch<React.SetStateAction<number>>;
}

const SectorContext = createContext<SectorContextType>({sector: 1, setSector: undefined as any});
export default SectorContext;
